import {
    Box,
    Checkbox,
    FormControlLabel,
    Tooltip,
    Typography,
} from '@mui/material';
import { Info } from 'lucide-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useRecoilState, useRecoilValue } from 'recoil';
import { selectedPatientIdState } from '~/state/atoms/patientAtoms';
import { pseudonymizeState } from '~/state/atoms/viewerAtoms';

type PseudonymizeCheckboxProps = {
    disabled?: boolean;
};

const PseudonymizeCheckbox = ({
    disabled = false,
}: PseudonymizeCheckboxProps) => {
    const intl = useIntl();
    const [pseudonymizeData, setPseudonymizeState] =
        useRecoilState(pseudonymizeState);
    // Turning it off holds for the selected patient, so with none it cannot.
    const noPatientSelected = useRecoilValue(selectedPatientIdState) === null;

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="end"
            position="relative"
            ml={-1}
        >
            <FormControlLabel
                control={
                    <Checkbox
                        data-testid="pseudonymizeCheckbox"
                        onChange={(_, checked) => setPseudonymizeState(checked)}
                        size="small"
                        color="primary"
                        checked={pseudonymizeData}
                        disabled={disabled || noPatientSelected}
                    />
                }
                label={
                    <Typography variant="body2" fontSize={13} lineHeight={1}>
                        <FormattedMessage id="deIdentifyData" />
                    </Typography>
                }
                sx={{ mr: 2 }}
            />
            <Tooltip
                title={
                    <Box p={1} maxWidth={200} whiteSpace="normal">
                        <Typography variant="caption" color="inherit">
                            <FormattedMessage id="deIdentifyDataTooltip" />
                        </Typography>

                        <Typography variant="body2" fontSize={11} mt={0.5}>
                            <FormattedMessage id="deIdentifyDataTooltip.off" />
                        </Typography>
                    </Box>
                }
                placement="right-start"
            >
                <Box
                    component="span"
                    tabIndex={0}
                    role="img"
                    aria-label={intl.formatMessage({
                        id: 'deIdentifyDataTooltip',
                    })}
                >
                    <Info size={10} aria-hidden />
                </Box>
            </Tooltip>
        </Box>
    );
};

export default PseudonymizeCheckbox;
